export const environment = {
  production: false,
  API_URL: 'https://neuberg-dev-api.algohealth.ai/',
  AUTH_URL: 'https://dev-neuberg.algohealth.ai/cdss-auth/',
  ENGINE_URL: '',
  captchaSiteKey: '6LfhIjcnAAAAAL1ncAcgz3a8oW46bBZrA_BLMPxP',
  googleClientId: '840151798335-985b64bp751lmsqegu89ufh3m2dgdm5i.apps.googleusercontent.com',
  encryptionKey: 'AIgopubIicid',
  forInsurence: true,
  logRocketToken: 'uftzni/algo-health-public',
  idleLogoutTime: 100*60*1000, //10 Mins
};